<template>
  <div id="AddExamScores">
    <v-app-bar extended extension-height="10" class="grey lighten-3 desktopHeader--remove hidden-md-and-up" fixed elevate-on-scroll>
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center mt-2">Add Score</span>
        <v-layout row align-baseline class=" ">
            <span class="subheading grey--text">{{exam.exam_type}} </span>
        </v-layout>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
      <div class="HealthcareHours__cover offset-md-3 col-md-6 offset-sm-2 col-sm-8 ">
        <div @click="back" class="headerFake__back">
            <a class="headerFake__backLink">
              <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
              <span class="headerFake__backText">Back</span>
            </a>
        </div>
        <v-card class=" mb-5 pt-5" flat >
          <v-layout column align-center class="justify-center hidden-sm-and-down">
            <span class="title light-blue--text text--darken-3 text-center mt-2">Add Score</span>
            <v-layout row align-baseline class=" ">
                <span class="subheading grey--text">{{exam.exam_type}} </span>
            </v-layout>
          </v-layout>
          <v-card-text class="mt-0 pt-0 px-0">
            <v-container grid-list-md>
              <!-- GRE Scores -->
              <v-form v-if="exam.exam_type === 'GRE'">
                <v-card
                  class="mx-auto mt-4 elevation-0 "
                  >

                  <v-card-title class="title font-weight-regular justify-space-between pl-0 pt-1 pb-1">
                  <v-layout justify-center> <span class=" green--text">{{ currentTitle }}</span></v-layout>

                  </v-card-title>
                  <v-window v-model="step">
                    <!-- Raw GRE Score-->
                    <v-window-item :value="1" class="mt-3">

                      <v-text-field
                        v-model="exam.gre_combined_score"
                        label="Combined Score"
                        color="green"
                        clearable
                        outlined
                      ></v-text-field>

                      <v-text-field
                        v-model="exam.gre_verbal_reasoning_score"
                        label="Verbal Reasoning Score"
                        color="green"
                        outlined
                        clearable
                      ></v-text-field>

                      <v-text-field
                        v-model="exam.gre_analytical_writing_score"
                        label="Analytical Writing Score"
                        color="green"
                        outlined
                        clearable
                      ></v-text-field>


                      <v-text-field
                        v-model="exam.gre_quantitative_reasoning_score"
                        label="Quantitative Reasoning Score"
                        color="green"
                        outlined
                        clearable
                      ></v-text-field>

                    </v-window-item>

                    <!-- Percentile GRE Scores -->
                    <v-window-item :value="2" class="mt-3">

                      <v-text-field
                        v-model="exam.gre_combined_percentile_score"
                        label="Combined %"
                        color="green"
                        clearable
                        outlined
                      ></v-text-field>

                      <v-text-field
                        v-model="exam.gre_verbal_percentile_score"
                        label="Verbal % "
                        color="green"
                        clearable
                        outlined
                        class="mt-0 pt-1"
                      ></v-text-field>


                      <v-text-field
                        v-model="exam.gre_quantitative_percentile_score"
                        label="Quantitative % "
                        color="green"
                        clearable
                        outlined
                        class="mt-0 pt-1"
                      ></v-text-field>


                      <v-text-field
                        v-model="exam.gre_analytical_percentile_score"
                        label="Analytical Writing % "
                        color="green"
                        outlined
                        clearable
                        class="mt-0 pt-1"
                      ></v-text-field>
                    </v-window-item>

                  </v-window>

                  <v-card-actions class="pt-5 ">

                    <v-btn
                      :disabled="step === 1"

                      @click="step--"
                      v-if="step !== 1"
                      >
                      Back
                    </v-btn>

                    <v-btn
                      v-if="step !== 2"
                      color="info"
                      depressed
                      block
                      large
                      @click="step++"
                      >
                      Next
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="step === 2"
                      color="success"
                      depressed

                      @click="saveExamScores()"
                      >
                      Save
                    </v-btn>
                  </v-card-actions>

                </v-card>

              </v-form>
              <!-- MCAT Scores -->
              <v-form v-if="exam.exam_type === 'MCAT'">
                <v-text-field
                  v-model="exam.mcat_total_score"
                  label="MCAT Total Score"
                  color="green"
                  outlined
                  clearable
                ></v-text-field>
              </v-form >
              <!-- TOEFL iBT Scores -->
              <v-form v-if="exam.exam_type === 'TOEFL iBT'">
                <v-text-field
                  v-model="exam.toeflIbt_total_score"
                  label="Total Score"
                  color="green"
                  outlined
                  clearable
                ></v-text-field>

                <v-text-field
                  v-model="exam.toeflIbt_reading_score"
                  label="Reading Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflIbt_writing_score"
                  label="Writing Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflIbt_listening_score"
                  label="Listening Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflIbt_speaking_score"
                  label="Speaking Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>
              </v-form>

              <!-- TOEFL pBT Scores -->
              <v-form v-if="exam.exam_type === 'TOEFL PBT'">
                <v-text-field
                  v-model="exam.toeflPbt_total_score"
                  label="Total Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>

                <v-text-field
                  v-model="exam.toeflPbt_reading_score"
                  label="Reading Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflPbt_writing_score"
                  label="Writing Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>


                <v-text-field
                  v-model="exam.toeflPbt_listening_score"
                  label="Listening Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>
              </v-form>

              <!-- PTE Academic Scores -->
              <v-form v-if="exam.exam_type === 'PTE Academic'">
                <v-text-field
                  v-model="exam.pteAcademic_overall_score"
                  label="Overall Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>
              </v-form>

              <!-- IELTS Scores -->
              <v-form v-if="exam.exam_type === 'IELTS'">
                <v-text-field
                  v-model="exam.ielts_overall_score"
                  label="Overall Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>
              </v-form>

              <!-- MELAB Score -->
              <v-form v-if="exam.exam_type === 'MELAB'">
                <v-text-field
                  v-model="exam.melab_overall_score"
                  label="Overall Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>
              </v-form>

              <!-- iTEP Academic Score -->
              <v-form v-if="exam.exam_type === 'iTEP Academic'">
                <v-text-field
                  v-model="exam.itepAcademic_overall_score"
                  label="Overall Score"
                  color="green"
                  clearable
                  outlined
                ></v-text-field>
              </v-form>

              <v-layout row class="mt-2 mb-3">
                <v-btn
                  v-if="exam.exam_type !== 'GRE'"
                  color="green"
                  @click="saveExamScores()"
                  block
                  depressed
                  large
                  >

                  <span class="white--text"> Save Score</span>
                </v-btn>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <!-- Back Button -->
    <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
  </div>
</template>

<script>
export default {
  data () {
    return {
      step: 1,
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    saveExamScores () {
      // Add GRE Data
        if(this.exam.exam_type === 'GRE') {
          const greExamData = {
            id: this.id,
            gre_combined_score: this.exam.gre_combined_score,
            gre_verbal_reasoning_score: this.exam.gre_verbal_reasoning_score,
            gre_analytical_writing_score: this.exam.gre_analytical_writing_score,
            gre_quantitative_reasoning_score : this.exam.gre_quantitative_reasoning_score,
            gre_combined_percentile_score : this.exam.gre_combined_percentile_score,
            gre_verbal_percentile_score: this.exam.gre_verbal_percentile_score,
            gre_quantitative_percentile_score: this.exam.gre_quantitative_percentile_score,
            gre_analytical_percentile_score: this.exam.gre_analytical_percentile_score,
            exam_scores : true
          }
          this.step = 1
          this.$store.dispatch('setAddExamScores', greExamData)
        }

        // Add MCAT Data
        if(this.exam.exam_type === 'MCAT') {
          const mcatExamData = {
            id: this.id,
            mcat_total_score: this.exam.mcat_total_score,
            exam_scores: true
          }

          this.$store.dispatch('setAddExamScores', mcatExamData)
        }

        // add TOEFL iBT Data
        if(this.exam.exam_type === 'TOEFL iBT') {
          const toeflIbtExamData = {
            id: this.id,
            toeflIbt_total_score: this.exam.toeflIbt_total_score,
            toeflIbt_reading_score: this.exam.toeflIbt_reading_score,
            toeflIbt_listening_score: this.exam.toeflIbt_listening_score,
            toeflIbt_speaking_score: this.exam.toeflIbt_speaking_score,
            toeflIbt_writing_score: this.exam.toeflIbt_writing_score,
            exam_scores : true
          }

          this.$store.dispatch('setAddExamScores', toeflIbtExamData)
        }

        // Add TOEFL PBT Data
        if(this.exam.exam_type === 'TOEFL PBT') {
          const toeflPbtExamData = {
            id: this.id,
            toeflPbt_total_score: this.exam.toeflPbt_total_score,
            toeflPbt_reading_score: this.exam.toeflPbt_reading_score,
            toeflPbt_writing_score: this.exam.toeflPbt_writing_score,
            toeflPbt_listening_score: this.exam.toeflPbt_listening_score,
            exam_scores : true
          }

          this.$store.dispatch('setAddExamScores', toeflPbtExamData)
        }

        // Add PTE Academic Data
        if(this.exam.exam_type === 'PTE Academic') {
          const pteAcademicExamData = {
            id: this.id,
            pteAcademic_overall_score: this.exam.pteAcademic_overall_score,
            exam_scores : true
          }

          this.$store.dispatch('setAddExamScores', pteAcademicExamData)
        }
        // Add IELTS Data
        if(this.exam.exam_type === 'IELTS') {
          const ieltsExamData = {
            id: this.id,
            ielts_overall_score: this.exam.ielts_overall_score,
            exam_scores : true
          }

          this.$store.dispatch('setAddExamScores', ieltsExamData)
        }

        // Add MELAB Data
        if(this.exam.exam_type === 'MELAB') {
          const melabExamData = {
            id: this.id,
            melab_overall_score: this.exam.melab_overall_score,
            exam_scores : true
          }

          this.$store.dispatch('setAddExamScores', melabExamData)
        }

        // Add iTEP Academic Data
        if(this.exam.exam_type === 'iTEP Academic') {
          const itepAcademicExamData = {
            id: this.id,
            itepAcademic_overall_score: this.exam.itepAcademic_overall_score,
            exam_scores : true
          }

          this.$store.dispatch('setAddExamScores', itepAcademicExamData)
        }
         this.$router.go(-1)
    }
  },
  computed: {
    id () {
        return this.$route.params.id
      },
     exam() {
      return this.$store.getters.examInfo(this.id);
    },
     currentTitle () {
        switch (this.step) {
          case 1: return 'GRE Scores'
          default: return 'GRE Percentiles'
        }
      }
  }
}
</script>

<style scoped>
  #headerToolbar {
    position: sticky;
    box-shadow: 0 10px 30px -10px #11111130;
  }
  .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }

 .card--flex-toolbar {
    margin-top: -64px;
  }
.headerFake__back {
  text-align: left;
  position: relative;
  display: none;
}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Exams/AddExamScores.vue